import React from 'react';
import {
    Row,
    Col,
    Container
} from "reactstrap";
import "assets/scss/loadings.scss"

const Loading = ({ tipo }) => {
    if (tipo === 'preloader') {
        return (
            <>
                <div className="holder">
                    <div className="preloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </>
        )

    } else if (tipo === 'paginas') {
        return (
            <>
                <div className="content">
                    <Container>
                        <Row className="centralizar">
                            <Col md="12">
                                <div className="holder">
                                    <div className="preloader">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )

    } else if (tipo === 'componente') {
        return (
            <>
                <div className="loadChart">
                    <div className="loading">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    </div>
                </div>
            </>
        )
    }
}
export default Loading;